import styles from "@styles/forms-flow/creative.module.scss";

import { Checkbox, Hairline, Input, Label, Message, Select } from "@components";
import { If } from "@components/control-statements";
import { useEffect, useState } from "react";
import { GodMode } from "shared/core/GodMode";
import { Environment } from "shared/core/Environment";

export const CreativeName = ({
  node,
  flowType,
  restrictions,
  creative,
  onChangeCreative,
}) => {
  const interval_options = useTimeIntervalOptions(node?.type, restrictions);

  useEffect(() => {
    if (creative?.sendTime == null && interval_options.length > 0) {
      const first_option = interval_options[0].value;
      onChangeCreative({ sendTime: first_option });
    }
  });

  return (
    <>
      <Label>Insira o nome do criativo</Label>
      <Input
        placeholder="Nome do criativo"
        value={creative?.name}
        autoFocus
        onChange={(text) => onChangeCreative({ name: text.target.value })}
      />
      <If cond={flowType != "EVENT"}>
        <Hairline className="mt-30 mb-30" />
        <Label>Insira o momento do disparo</Label>
        <Select
          options={interval_options}
          value={creative?.sendTime}
          onChange={(e) => onChangeCreative({ sendTime: e.target.value })}
        />
      </If>
      <Hairline className="mt-30 mb-30" />
      <If cond={GodMode.isGodMode || Environment.id == 34}>
        <Checkbox
          name="enabled"
          design="two"
          className="mb-15"
          checked={creative?.enabled === false}
          onChange={(enabled) =>
            onChangeCreative({ enabled: enabled === false })
          }
        >
          Somente contemplação (CiaTC)
        </Checkbox>
      </If>
      <If cond={flowType == "EVENT"}>
        <Message visible>
          O criativo será disparado quando o evento selecionado for identificado
        </Message>
      </If>
    </>
  );
};

const useTimeIntervalOptions = (node_type, restrictions) => {
  const [options, setOptions] = useState(
    getTimeIntervalOptions(node_type, restrictions),
  );

  const handler = () => {
    setOptions(getTimeIntervalOptions(node_type, restrictions));
  };

  useEffect(handler, [restrictions]);
  return options;
};

const getTimeIntervalOptions = (node_type, restrictions) => {
  const horaries = [];

  const start_hour = restrictions?.lockBeforeCreativeTime
    ? new Date().getHours() + (node_type == "PushCreativeAction" ? 1 : 2)
    : 0;

  for (let i = start_hour; i <= 22; i++) {
    horaries.push({
      value: `${String(i).padStart(2, "0")}:00`,
      label: `${String(i).padStart(2, "0")}h - ${String(i + 1).padStart(2, "0")}h`,
    });
  }

  horaries.push({
    value: `23:00`,
    label: `23h - 00h`,
  });

  if (node_type == "PushCreativeAction") {
    horaries.unshift({
      value: `${String(new Date().getHours()).padStart(2, "0")}:00`,
      label: `Disparo ao publicar`,
    });
  }

  return horaries;
};
